import React from 'react';
import classNames from 'classnames';
const Row = ({ children, className, form, noGutters, attribute, tag = 'div' }) => {
    const resultClassName = classNames(className, noGutters ? 'no-gutters' : null, form ? 'ac-form-row' : 'ac-row');
    if (tag === 'ol') {
        return (React.createElement("ol", Object.assign({}, attribute, { className: resultClassName }), children));
    }
    else if (tag === 'ul') {
        return (React.createElement("ul", Object.assign({}, attribute, { className: resultClassName }), children));
    }
    else {
        return (React.createElement("div", Object.assign({}, attribute, { className: resultClassName }), children));
    }
};
export { Row };
//# sourceMappingURL=Row.js.map